import { render, staticRenderFns } from "./railway-control-content-header-calendar-item.vue?vue&type=template&id=6887bd15"
import script from "./railway-control-content-header-calendar-item.vue?vue&type=script&lang=js"
export * from "./railway-control-content-header-calendar-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports